import { createFileRoute } from "@tanstack/react-router";
import { permanentRedirect } from "@/lib/legacyRedirects";

/** Gammal söksida – permanent omdirigering till jämförelsesidan. */
export const Route = createFileRoute("/sok")({
  beforeLoad: ({ location }) =>
    permanentRedirect(`/elavtal/jamfor${location.searchStr ?? ""}`),
});
